<template>
  <div class="role">
    <a-spin :spinning="spinning">
    <!-- ----------------- -->
    <div class="role-title">
      角色管理
    </div>
    <!-- 搜索 -->
    <div class="serach-warp">
      <div class="margin-right-15" style="display: inline-block;vertical-align: top;">
        <search @onSearch="onSearch" placeholder="请输入角色名搜索" />
      </div>
      <div style="display: inline-block;vertical-align: top;">
        <a-button  v-if="hasPerm('/admin/system/role/add')" class="createrBtn" @click="showCreateClick">创建角色</a-button>
      </div>
    </div>
    <!-- 表格 -->
    <role-table ref="roleTable" />
    <!-- 创建角色 -->
    <a-modal v-model="visible"
            :mask="true"
            :centered="true"
            :footer="null"
            :maskClosable="true"
    >
      <div class="createTitle">创建角色</div>
      <a-form-model ref="createRole" v-bind="layout" :model="roleInfo" :rules="roleInfoRules">
        <a-form-model-item has-feedback label="角色名称" prop="name">
          <a-input v-model="roleInfo.name" type="text" :maxLength="150" autocomplete="off" />
        </a-form-model-item>

        <a-form-model-item has-feedback label="角色描述" prop="remark">
          <a-input v-model="roleInfo.remark" type="text" :maxLength="150" autocomplete="off" />
        </a-form-model-item>

      </a-form-model>

      <div class="btn-wrap">
        <a-button class="cancel margin-right-15" @click="cancel">取消</a-button>
        <a-button class="create" @click="submitForm('createRole')">创建</a-button>
      </div>

    </a-modal>
    </a-spin>
  </div>
</template>

<script>
import { CreateRole } from "api/role"

import search from "@/components/content/search/Search";
import RoleTable from './childComps/RoleTable';
import {hasPermission} from 'utils/hasPermission'

export default {
  name: 'Role',
  components: {
    search,
    RoleTable
  },
  data() {
    let checkPending;
    let validateNickname = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('角色名称不能为空'));
      } else {
        callback();
      }
    };
    return {
      spinning: false,
      layout: {
        labelCol: { span: 4 },
        wrapperCol: { span: 20 },
      },
      visible: false,

      roleInfo: {
        name: "",
        remark: "",
      },

      roleInfoRules: {
        name: [{validator: validateNickname, trigger: 'change'}],
      }
    }
  },
  methods: {
    hasPerm(perm){
      return hasPermission(perm);
    },
    /**
    * 逻辑区
    */
    // 加载动画
    loading() {
      this.spinning = !this.spinning
    },
    // 搜索
    onSearch(value) {
      this.$refs.roleTable.roleName = value;
      this.$refs.roleTable.pageIndex = 0;
      this.$refs.roleTable.pagination.current = 1;
      this.$refs.roleTable.getRoleListData(0, 10, value)
    },
    // 显示创建角色
    showCreateClick() {
      this.roleInfo = {
        name: "",
        remark: "",
      }
      this.visible = !this.visible;
    },
    // 取消创建
    cancel() {
      console.log("取消创建");
      this.visible = !this.visible;
      this.roleInfo = {
        name: "",
        remark: "",
      }
    },
    // 创建角色
    submitForm(formName) {
      const vm = this;
      this.$refs[formName].validate(valid => {
        if (valid) {
          vm.create()
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    /**
    * 接口区
    */
    create() {
      const vm = this;
      this.spinning = true
      CreateRole(this.roleInfo.name, this.roleInfo.remark)
        .then(res => {
          console.log(res);
          vm.spinning = false
          if (res.code !== 0) {
            vm.$message.error(res.message || res.msg || '创建角色失败');
          } else {
            vm.$message.success('创建角色成功！');
            vm.visible = false;
            vm.onSearch(this.$refs.roleTable.roleName);
          }
        })
        .catch(err => {
          vm.spinning = false
          console.log(err);
        })
    }
  }
}
</script>

<style lang='scss' scoped>
  .role {
    .role-title {
      font-size: 30px;
      font-weight: 500;
      color: #131212;
    }
    .serach-warp {
      margin: 15px 0;
      .createrBtn {
        color: #fff;
        background-color:rgba($color: #E84D11, $alpha: .6)
      }
    }
  }

  .createTitle {
    line-height: 45px;
    font-size: 28px;
    font-weight: 500;
    text-align: center;
    color: #131212;
    margin-bottom: 30px;
  }
  .btn-wrap {
    text-align: center;
    margin-top: 10px;
    .create {
      color: #fff;
      background-color: #E84D11;
    }
  }
</style>
